import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IListaPersonasRequest, IListPersonasResponse, IListaPersonasAddResponse, IPersonaDetalleResponse } from '../interfaces/list-personas.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListPersonasService {
  private baseUrl = environment.apiNewBackBaseUrl + 'ListaPersonas/cmspa_ctenegList';
  private deleteUrl = environment.apiNewBackBaseUrl + 'ListaPersonas/cmspa_ctenegDelete';
  private readonly apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getListPersonas(request: IListaPersonasRequest): Observable<IListPersonasResponse> {
    return this.http.post<IListPersonasResponse>(this.baseUrl, request);
  }

  deletePersona(request: IListaPersonasRequest): Observable<IListaPersonasAddResponse> {
    return this.http.post<IListaPersonasAddResponse>(this.deleteUrl, request);
  }

  addListaPersona(request: IListaPersonasRequest): Observable<IListaPersonasAddResponse> {
    return this.http.post<IListaPersonasAddResponse>(`${this.apiUrl}ListaPersonas/cmspa_ctenegAdd`, request);
  }

  editPersona(request: IListaPersonasRequest): Observable<IPersonaDetalleResponse> {
    return this.http.post<IPersonaDetalleResponse>(`${this.apiUrl}ListaPersonas/cmspa_ctenegListClient`, request);
  }

  updatePersona(request: IListaPersonasRequest): Observable<IListaPersonasAddResponse> {
    return this.http.post<IListaPersonasAddResponse>(`${this.apiUrl}ListaPersonas/cmspa_ctenegUpd`, request);
  }
} 